
import store from '../store/store'
import axios from './http'
import {addstamp} from '../util/stamp';
import apiURL from './api'
export function checkheadimg() {
    var head_img = ''
    var stamp = parseInt(store.state.timestamp)
    if(typeof stamp != 'number'){
        stamp = 631123201000
      }
      // console.log(stamp)
    var s1 = stamp,
    // 此刻时间
    s2 = new Date().getTime(),
    // 间隔秒数
    runTime = parseInt((s2 - s1) / 1000);
    // 间隔小时
    var hour = runTime / 3600;
    var number = Math.round(hour * 100) / 100
    // console.log(number)
    if(number>=2){
        // console.log('>=2')
        var params = {
            user_id: store.state.user_id
        }
        var sign = addstamp(params)
        delete params.token
        params['sign'] = sign
        // console.log(params)
        var baseURL = apiURL
        $.ajax({
            url: baseURL+"new_head_img/"+store.state.user_id,
            type:'GET',
            async:false,
            data:params,
            timeout:12000,    //超时时间
            dataType:'json',    //返回的数据格式：
            beforeSend:function(xhr){
            },
            success:function(data,textStatus,jqXHR){
              // console.log(data)
              if (data.status_code == 200) {
                head_img = data.data.head_img
                store.commit("setheadimg", head_img);
                store.commit("settimestamp", s2);
              }
            },
            error:function(xhr,textStatus){
            },
            complete:function(){
            }
          })
    }else{
      // console.log('<=2')
        head_img = store.state.head_img
        // console.log(store.state.head_img)
      }
      // console.log(head_img)
    return head_img
};



// WEBPACK FOOTER //
// ./src/util/checkhead_img.js